<template>
  <div>
    <div  v-if="loading">
      <skeleton-revenue />
    </div>
    <div class="vuse-content-wrapper mt-4" v-if="customers">
      <div>
          <v-row >
            <v-col>
              <h2 class="ml-3">
                {{$t(page+'.title')}}
                <span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn icon color="primary" v-on="on" @click="xmlReport">
                        <v-icon>file_download</v-icon>
                      </v-btn>
                    </template>
                    <span>Download Table as CSV</span>
                  </v-tooltip>
                </span>
                <span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">     
                      <v-btn icon color="primary" v-on="on" @click="loadData">
                        <v-icon>sync</v-icon>
                      </v-btn>
                    </template>
                    <span>Refresh</span>
                  </v-tooltip>
                </span>
              </h2>
            </v-col>
            <v-spacer /> 
          </v-row>
          <template v-if="!customers && !loading">
            <no-data />  
          </template>
          <template v-else>  
            <v-row class="pl-1 px-5 mt-2">
              <v-col cols="12" class="ma-2">
                <v-card class="neu-glow pb-4">
                  <v-card-title>
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-data-table
                      v-if="customers"
                      dense
                      height="635"
                      fixed-header="true"
                      :headers="i18_headers"
                      :items="customers"
                      :items-per-page="50"
                      :search="search"
                      multi-sort
                      class="elevation-1 mx-4"
                      :loading="loading" 
                      loading-text="Loading... Please wait"

                  >
                    <template #item.index="{ item }">
                      {{ customers.indexOf(item)+1 }}
                    </template>
                    <template v-slot:item.FWD_Enabled="{ item }">
                      <v-simple-checkbox color="primary" v-model="item.FWD_Enabled" readonly></v-simple-checkbox>
                    </template>
                    <template v-slot:item.Filter_Enabled="{ item }">
                      <v-simple-checkbox color="primary" v-model="item.Filter_Enabled" readonly></v-simple-checkbox>
                    </template>
                  </v-data-table>
                  </v-card>
              </v-col>
            </v-row>
          </template>
        </div>
    </div>
    <v-dialog v-model="msg_modal" max-width="850">
      <v-card class="overflow-hidden">
        <v-card-title class="text-h5"
          >Send a Message</v-card-title
        >
          <v-row  class="mt-5">
            <v-col cols="12" md="6">
              <v-img
                src="/static/ob-animated/sent-message-animate.svg"
                lazy-src="/static/ob-animated/sent-message-animate.svg"
                style="height:100%"
              ></v-img>
            </v-col>
            <v-col>
              <v-card-text class="mt-2">
                <p>Send a Message to... {{username}}</p>
                  <v-text-field
                    label="Subject"
                    placeholder="Subject"
                    outlined
                    v-model="msg.subject"
                  ></v-text-field>
                  <v-textarea
                    outlined
                    v-model="msg.body"
                    name="input-7-4"
                    label="Message Text"
                  ></v-textarea>
                <div class="text-left mt-5">
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <v-btn 
                        class="ml-5"
                        color="primary"
                        @click="messageSend"
                      >Send</v-btn>
                    </v-col>
                  </v-row>
                  </div>
              </v-card-text>
            </v-col>
          </v-row>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" absolute top right :color="snackbar_color">
      <span>{{snackbar_text}}</span>
    </v-snackbar>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import NoData from "@/components/NoData";
import SkeletonRevenue from "@/components/SkeletonRevenue";

export default {
  components: { NoData, SkeletonRevenue },
  computed : {
    ...mapGetters(["user"]),
    i18_headers: function()
    {
      let H= this.headers
      H.map(h => 
      {
        h.text=this.$t(this.page+'.'+h.text);    
      });
      return H;
    },
  },
  data() {
    return {
      namespace: "Reports",
      page: "PayPal",
      UserID:null,
      username:'',
      msg_modal:false,
      msg:{},
      loading: true,
      errorid: null,
      search: '',
      customers: null,
      snackbar:false,
      snackbar_text:'',
      snackbar_color:'',
      headers: [
          { text: '#', align: 'start', value: 'index'},
          { text: 'Registration Date', align: 'start', value: 'CreatedTime'},
          { text: 'UserName', value: 'UserName' },
          { text: 'PayPal Email', value: 'PayPalEmail' },
          { text: 'Binding Date', value: 'PP_CreatedTime' },
          { text: 'Received IPN', value: 'IPN_Count' },
        ],      
    };
  },
  created(){
    this.loadData()
  },
  methods:
  {
    openModal(userid,username)
    {
      this.msg_modal=true;
      this.msg.userid=userid;
      this.username=username;

    },
    async xmlReport(){
      let jwt=sessionStorage.getItem('jwt');
      let payload={"jwt":jwt};
      window.location.href='/ajax/boss/customers_xls.php?json='+encodeURIComponent(JSON.stringify(payload));
    },
    async loadData(){
      let jwt=sessionStorage.getItem('jwt');
      //this.loading=true;
      try
      {
          const res = await this.$http.post('/boss/paypal.php', {"jwt":jwt});
          this.loading= false;
          this.errorid=res.data.errorid;
          switch (res.data.errorid)
          {
            case '0':
              this.customers=res.data.payload.table;
              console.log(this.customers);
            break;

            case '0001':
              this.data.datasets[0].data = res.data.payload.data0;
              this.data.datasets[1].data = res.data.payload.data1;
              this.data.datasets[2].data = res.data.payload.data1;
              this.data.datasets[3].data = res.data.payload.data1;
              this.data.labels = res.data.payload.labels; 
            break;

            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }

      }
      catch(e)
      {
          this.loading= false;
      }
    },
  }
};
</script>